/* eslint-disable */ 
import {useState, useEffect } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast } from '@chakra-ui/react'; 

import { useParams, Redirect } from 'react-router-dom'

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';

import service from 'services/reclamosLineaService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
	wrco: string;
    wrY56EXREC: number;
    wrY55HOJOB: number;
    wrY55IMJOB: number;
    wrcodexpbu: number;
    wrY55CARGO: number;
    wrY55NOPRO: string;
    wrY55HATA: string;
    wrmcU2: string;
    wrdc: string;
    wrY55TIOP: string;
    wrY55TIEM: string;
    wrY55COCO: number;
    wralph: string;
    wrdgj: string;
    wrdgl: string;
    wrdgJ_String: string;
    wrdgL_String: string;
    wrY56EXREC_String: string;
    wrY55HOJOB_String: string;
    wrY55IMJOB_String: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION, LAYOUT_PRIVADO, PATH_RECLAMOS_LINEA } from "const/CommonConst";

export default function DataTable() {
	
	let { codigo, codigo1, codigo2 } = useParams();
	
	if (codigo === undefined || codigo === null || codigo === '' 
			|| codigo1 === undefined || codigo1 === null || codigo1 === '' 
			|| codigo2 === undefined || codigo2 === null || codigo2 === '') {
	  return <Redirect to= {`${LAYOUT_PRIVADO}${PATH_RECLAMOS_LINEA}`} />
	}

  const textColor = useColorModeValue("navy.700", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");  
  const brandColor = useColorModeValue("brand.500", "brand.400");
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

  const toast = useToast()

  const [tableData, setTableData] = useState([]);

  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(true);
  const [showProgressSearch, setShowProgressSearch] = useState(false);
  const [showProgressExport, setShowProgressExport] = useState(false);
  

  const fetchData = async () => {
    return await service.getTablaDetalle(codigo, codigo1, codigo2);
  };

  useEffect(async () => {
	const data = await fetchData();

	if (data && data.length > 0)
	{
		const header = data[0];
		
		setTableData(data)
		setDisabledActions(false)
	}
	else{
		setTableData([])
		setDisabledActions(true)
	}
	
},[codigo, codigo1, codigo2]);

 
    const columnHelper = createColumnHelper<RowObj>();
 	const columns = [
		columnHelper.accessor('wrY56EXREC_String', {
			id: 'wrY56EXREC_String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE DE RECLAMO
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('wrY55NOPRO', {
			id: 'wrY55NOPRO',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					ETAPA
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('wrY55HATA', {
			id: 'wrY55HATA',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					HORA
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('wrdgJ_String', {
			id: 'wrdgJ_String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					FECHA
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		})		
	];
	
  return ( 
    <CommonDatatable
    columnsDefinition={columns}
    tableData={tableData}
	showEmptyState={showEmptyState}
	isLoading={disabledActions} />        
  )
} 
